/* eslint-disable no-unused-vars */
import {
  getToken,
  getQueues,
  getStyles,
  getEnvOnly,
  getMenus,
  sendRecords,
  tracking
} from "../../helpers/Meet";
import {
  autorizar,
  citas,
  enCentroMedico,
  enOficina,
  validarPago
} from "../../helpers/colmedica_fila_virtual";
import { getAppoiments } from "../../helpers/Appoiments";
import { get as _get, omit as _omit } from "lodash";
import LS from "../../helpers/localStorage";

/**
 * Data for demo porpouses
 */
import CentroDemo from "./CentroDemo";
import OficinaDemo from "./OficinaDemo";
import CitasDemo from "./CitasDemo";
import ValPagoDemo from "./ValidarpagocitaDemo";


const ENABLE_CITAS_API = false;

export default {
  changeAuth({ commit }, value) {
    commit("setState", { key: "showAuth", value });
  },

  setCustomArea({ commit }, value) {
    commit("setState", { key: "customArea", value });
  },

  setUserActionDate({ commit }, value) {
    commit("setState", { key: "userActionDate", value });
  },

  async getSites({ commit }) {
    const sites = await getQueues();
    if (sites && sites.length)
      commit("setState", { key: "sites", value: sites });
  },

  async getStyles({ commit }) {
    try {
      const styles = await getStyles();
      commit("setState", {
        key: "primaryColorBlue",
        value: styles?.bsix_client?.companyColor
      });
      commit("setState", {
        key: "secondColorBlue",
        value: styles?.bsix_client?.secondaryCompanyColor
      });
      commit("setState", {
        key: "threeColorBlueColor",
        value: styles?.bsix_client?.contrastTextColor
      });
    } catch (error) {
      console.error("Cant get Styles", error);
    }
  },

  async getMenus({ commit }, { code, area }) {
    const { menu, actions, customMenu } = await getMenus(code);
    commit("setState", { key: "menu", value: customMenu[area] || menu });
    commit("setState", { key: "actions", value: actions });
  },

  goToView({ commit, state, dispatch }, { view }) {
    if (state.isAtril) {
      dispatch("setTimer", true, {
        root: true,
        state: { ...state, timer: 98 }
      });
    }
    commit("setState", { key: "view", value: view });
    let newArray = JSON.parse(JSON.stringify(state.history));
    newArray.push(view);
    commit("setState", { key: "history", value: newArray });
  },

  setExplanation({ commit }, value) {
    commit("setState", { key: "explanation", value });
  },

  selecteService({ commit }, value) {
    commit("setState", { key: "servicioSelected", value });
  },

  goBack({ commit, state }) {
    let newArray = JSON.parse(JSON.stringify(state.history));
    newArray.pop();
    commit("setState", { key: "history", value: newArray });
    commit("setState", {
      key: "view",
      value: state.history[state.history.length - 1]
    });
  },

  async setCitaCM({ commit, dispatch, state }, value) {
    // Lf Tested 21-01-21
    commit("setState", { key: "charging", value: true });
    commit("setState", { key: "payment", value: false });
    commit("setState", { key: "citaActual", value });
    commit("setState", { key: "currentValidation", value: [] });
    console.log("value");
    console.log(value);
    try {
      const validation = (await dispatch("getCitaValidation", value)).sort(
        (a, b) => a.Orden - b.Orden
      );
      console.log("validation");
      console.log(validation);
      commit("setState", { key: "currentValidation", value: validation });
      if (validation.length) {
        if (validation[0]?.IdPaso > -1) {
          const sitioCorrecto =
            state.currentSite.code === 9955104 ||
            state.currentSite.code === 9956166 ||
            (state.currentSite.code === 9957122 &&
              state.customArea === "piso_4");
          // 9955104 - Centro Médico Centro Odontológico Colmédica Calle 84, Piso 7
          // 9956166 - Centro Colmédica Chapinero
          // 9957122 - Centro Médico Torre Colmédica Santa Bárbara, Piso 4
          const esOdontologia = value.Especialidad.toLowerCase().includes(
            "odontolog"
          );

          if (esOdontologia && sitioCorrecto) {
            let menuSelected;
            if (state.currentSite.code == 9956166) {
              // Odontologia en Centro Colmédica Chapinero
              menuSelected = state.menu.filter(
                menu => menu.label == "Odontología"
              );
            } else {
              menuSelected = state.menu.filter(
                menu => menu.label == "Cita Odontología Paga"
              );
            }
            // Use Odontologia menu
            commit("setState", {
              key: "selectedAccion",
              value:
                menuSelected[0] && menuSelected[0].children // TODO: Only 2 levels. If require multilevel, fix it with a recursive function
                  ? menuSelected[0].children[0]
                  : menuSelected[0]
            });
            commit("setState", { key: "payment", value: true });
            commit("setState", { key: "charging", value: false });
            dispatch("turnCall", false);
            return;
          } else {
            dispatch("goToView", { view: "Pay" });
            commit("setState", { key: "charging", value: false });
            return;
          }
        } else if (validation[0]?.IdPaso === -1) {
          // commit("setState", { key: "priority", value: true });
          if (
            value.Especialidad.includes("Odontologia") &&
            state.currentSite.code == 9956166
          ) {
            // Odontologia en Centro Colmédica Chapinero
            let menuSelected = state.menu.filter(
              menu => menu.label == "Odontología"
            );
            if (menuSelected.length) {
              // Use Odontologia menu
              commit("setState", {
                key: "selectedAccion",
                value:
                  menuSelected[0] && menuSelected[0].children // TODO: Only 2 levels. If require multilevel, fix it with a recursive function
                    ? menuSelected[0].children[0]
                    : menuSelected[0]
              });
            } else {
              // Use default menu
              commit("setState", {
                key: "selectedAccion",
                value:
                  state.menu[0] && state.menu[0].children // TODO: Only 2 levels. If require multilevel, fix it with a recursive function
                    ? state.menu[0].children[0]
                    : state.menu[0]
              });
            }
          } else {
            commit("setState", {
              key: "selectedAccion",
              value:
                state.menu[0] && state.menu[0].children // TODO: Only 2 levels. If require multilevel, fix it with a recursive function
                  ? state.menu[0].children[0]
                  : state.menu[0]
            });
          }
          commit("setState", { key: "charging", value: false });
          return dispatch("turnCall", false);
        }
      }
    } catch (error) {
      console.error("In setCitaCM action", error);
    }
    commit("setState", {
      key: "selectedAccion",
      value:
        state.menu[0] && state.menu[0].children // TODO: Only 2 levels. If require multilevel, fix it with a recursive function
          ? state.menu[0].children[0]
          : state.menu[0]
    });
    commit("setState", { key: "charging", value: false });
    return dispatch("turnCall", false);
  },

  setAction({ commit, dispatch }, value) {
    commit("setState", { key: "selectedAccion", value });

    // If the action has appoiment, go to the appoiments view
    if (value?.appoiment) {
      return dispatch("goToView", { view: "Appoiments" });
    }

    if (value?.openModal) {
      return dispatch("goToView", { view: "HelpInfo" });
    }
    if (value?.evaluationComponent)
      return dispatch("goToView", { view: value.evaluationComponent });
    if (value?.ignorePriority) dispatch("goToView", { view: "Turn" });
    else dispatch("goToView", { view: "Normativity" });
  },

  confirmedAction({ state, commit, dispatch }) {
    // /  state.selectedaction tiene ignorePriority?
    if (state.selectedAccion?.ignorePriority)
      dispatch("goToView", { view: "Turn" });
    else dispatch("goToView", { view: "Normativity" });
  },

  turnCall({ commit, dispatch }, value) {
    commit("setState", { key: "priority", value });
    dispatch("goToView", { view: "Turn" });
  },

  async getCitaValidation(ctx, { idCita }) {
    let toReturn = [];
    if (getEnvOnly().VUE_APP_DEMO_MODE === "true") {
      if (idCita === 23423) return ValPagoDemo.good;
      else return ValPagoDemo.bad;
    } else {
      try {
        toReturn = await validarPago({ idCita });
      } catch (error) {
        console.error("In getCitaValidation", error);
      }
    }
    return toReturn;
  },

  captchaValidation({ dispatch, commit, state }) {
    if (window.grecaptcha && window.grecaptcha.ready) {
      return new Promise((res, rej) => {
        window.grecaptcha.ready(() => {
          window.grecaptcha
            .execute(getEnvOnly().VUE_APP_RECAPTCHA_CODE, {
              action: "submit_identification"
            })
            .then(token =>
              getToken(token, "g_recaptcha_v3", {
                bunitId: getEnvOnly().VUE_APP_BUNIT
              })
            )
            .then(() => res())
            .catch(err => {
              commit("setState", {
                key: "validationErrors",
                value: [...state.validationErrors, err]
              });
              dispatch("errorValidationTemporizer");
              console.error("error in recaptcha request.");
              rej(err);
            });
        }); //
        // throw new Error('X ERROR');
      }).catch(err => {
        commit("setState", { key: "charging", value: false });
        console.error("Error cached in Autenticate.vue -> demoValidation", err);
        dispatch("goToView", { view: "ErrorAutenticate" });
      });
    }
    return Promise.reject(new Error("Recaptcha is not ready"));
  },

  async authenticate({ dispatch, commit, state }, toSend) {
    commit("setState", { key: "charging", value: true });
    commit("setState", { key: "payment", value: false });
    commit("setState", { key: "error", value: null });
    let nextComponent = {
      view: "ErrorAutenticate"
    };
    try {
      if (!state.isAtril) await dispatch("captchaValidation");
      try {
        await dispatch(
          getEnvOnly().VUE_APP_DEMO_MODE === "true"
            ? "demoValidation"
            : "authAndQuery",
          _omit(toSend, ["DisabledView"])
        );

        if (state.currentUser.Tipo == "P") {
          nextComponent.view = "HelpActive";
        } else {
          if (state.citas && state.citas.length) {
            nextComponent.view = "Quote";
          } else {
            nextComponent.view = "NoDate";
          }
        }
      } catch (error) {
        let message_error = error.message;
        if (message_error == "timeout") {
          console.error("Timeout in authorization", error);
          nextComponent.view = "NoDate";
        } else {
          console.error("Error in authorization", error);
          commit("setState", {
            key: "error",
            value: {
              zone: "authorization",
              message: "El usuario no se encuentra registrado en el sistema"
            }
          });
          dispatch("errorValidationTemporizer");
          nextComponent.view = "Help";
        }
      }
    } catch (error) {
      console.error("Error in Captcha", error);
      commit("setState", {
        key: "error",
        value: { zone: "recaptcha", message: "La validación del captcha falló" }
      });
      dispatch("errorValidationTemporizer");
    }
    if (toSend.DisabledView && toSend.DisabledView == true) {
      commit("setState", { key: "charging", value: false });
      return nextComponent;
    } else {
      dispatch("goToView", nextComponent);
      commit("setState", { key: "charging", value: false });
    }
  },

  async demoValidation({ commit, state }, toSend) {
    let userfinded = state.userDemo.find(
      usr => usr.NumeroIdentificacion == toSend?.NumeroIdentificacion
    );
    await new Promise(res => setTimeout(res, 2000));
    commit("setState", { key: "currentUser", value: toSend });
    LS.setItem("currentUser", toSend);
    if (!userfinded) throw new Error("Invalid demo User");
    let originFinded = (state.currentSite?.type === "cm"
      ? CentroDemo
      : OficinaDemo
    ).find(
      cm =>
        cm.TipoIdentificacion == toSend?.TipoIdentificacion &&
        cm.NumeroIdentificacion == toSend?.NumeroIdentificacion
    );
    if (!originFinded) throw new Error("User not have meetings");
    toSend = { ...toSend, ...originFinded };
    if (state.currentSite?.type === "of") {
      let appoimentData = await getAppoiments(toSend.NumeroIdentificacion);
      commit("setState", { key: "appoimentCall", value: false });
      commit("setState", {
        key: "appoimentData",
        value: appoimentData[0] || null
      });
    } else {
      if (
        state.currentSite?.type === "cm" &&
        toSend.NumeroIdentificacion === "789"
      )
        commit("setState", { key: "citas", value: CitasDemo });
      else commit("setState", { key: "citas", value: [] });
    }
    commit("setState", { key: "currentUser", value: toSend });
    LS.setItem("currentUser", toSend);
  },

  async authAndQuery({ state, commit }, _pay) {
    let pay = {
      ..._pay
      // Tipo: "N", // the type is commented while the api is released
    };
    console.log("****DATOS PARA AUTORIZAR***");
    console.log(pay);

    // autentication
    let inSite;
    try {
      // remove 99 from migration debmedia
      pay.CodigoOficina =
        pay.CodigoOficina.length > 5
          ? pay.CodigoOficina.slice(2)
          : pay.CodigoOficina;

      await autorizar({
        TipoIdentificacion: pay.TipoIdentificacion,
        NumeroIdentificacion: pay.NumeroIdentificacion,
        CodigoOficina: pay.CodigoOficina,
        Timeout: true
      });

      inSite = await (state.currentSite?.type === "cm"
        ? enCentroMedico
        : enOficina)(true);
      console.log(inSite);
      commit("setState", { key: "currentUser", value: { ...pay, ...inSite } });
    } catch (error) {
      commit("setState", { key: "currentUser", value: pay });
      if (_get(error, "code", "not-code") == "ECONNABORTED") {
        throw new Error("timeout");
      }
      throw new Error(error);
    }

    // check citas
    try {
      commit("setState", { key: "citas", value: [] });
      if (state.currentSite?.type === "cm") {
        const citasList = await citas();
        commit("setState", { key: "citas", value: citasList });
      }

      // check appoiments
      commit("setState", { key: "appoimentCall", value: false });
      commit("setState", { key: "appoimentData", value: null });
      if (state.currentSite?.type === "of") {
        const appoimentData = await getAppoiments(state.currentUser.NumeroIdentificacion);
        commit("setState", { key: "appoimentData", value: appoimentData[0] || null });
      }
    } catch (error) {
      if (_get(error, "code", "not-code") == "ECONNABORTED") {
        throw new Error("timeout");
      }
      throw new Error(error);
    }
  },

  handleSendRecords({ commit }, info) {
    return sendRecords(info)
      .then(response => {
        // commit("saveRecord", response);
        commit("setState", { key: "saveRecord", value: response });
        return response;
      })
      .catch(error => {
        // commit("errorRecord", error);
        commit("setState", { key: "errorRecord", value: error });
        return {
          response: false,
          message: error
        };
      });
  },

  handleTracking({ commit }, info) {
    return tracking(info)
      .then(response => {
        commit("setState", { key: "trackingRecord", value: response });
        return response;
      })
      .catch(error => {
        commit("setState", { key: "errorTrackingRecord", value: error });
        return {
          response: false,
          message: error
        };
      });
  },

  errorValidationTemporizer({ commit, state }) {
    if (state.errorValidationTemporizer !== null)
      clearTimeout(state.errorValidationTemporizer);
    if (state.error) return;
    let timer = setTimeout(() => {
      commit("setState", { key: "error", value: null });
      commit("setState", { key: "errorValidationTemporizer", value: null });
    }, 5000);
    commit("setState", { key: "errorValidationTemporizer", value: timer });
  },

  cleanCurrentUser({ commit }) {
    commit("setState", { key: "citaActual", value: null });
    commit("setState", { key: "currentUser", value: null });
    LS.removeItem("currentUser");
  }
};
